<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-07-28 19:58:21
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-08-05 14:59:34
-->
<template>
  <el-dialog
    custom-class="yzmDialog"
    :visible.sync="activityCheckVisible"
    :close-on-click-modal="false"
    width="350px"
    top="20vh"
  >
    <slide-verify
      class="yzm"
      :l="42"
      :r="10"
      :w="310"
      :h="155"
      :accuracy="10"
      :imgs="puzzleImgList"
      ref="slideblock"
      slider-text="向右滑动"
      @success="onSuccess"
      @fail="onFail"
      @refresh="onRefresh"
    ></slide-verify>
  </el-dialog>
</template>
<script>
import {
  shNeedCheck,
  getUserExpireTime,
  activeClock,
  activeError
} from "@/api/api";
import { getCookie, removeCookie } from "@/utils/cookies";
import { mapGetters } from "vuex";
let GetUserExpireTimer, LogoutTimer;
export default {
  name: "ActivityCheck",
  data() {
    return {
      token: "",
      puzzleImgList: [
        require("@/assets/yzm_bg_1.jpg"),
        require("@/assets/yzm_bg_2.jpg"),
        require("@/assets/yzm_bg_3.jpg"),
        require("@/assets/yzm_bg_4.jpg")
      ]
    };
  },
  computed: {
    ...mapGetters(["activityCheckVisible"])
  },
  mounted() {
    console.log(this.activityCheckVisible);
    this.token = getCookie("myToken");
    this.isNeedCheck();
    // setTimeout(() => {
    //   this.$store.commit("setActivityCheckVisible", true);
    // }, 3000);
  },
  methods: {
    isNeedCheck() {
      shNeedCheck({
        token: this.token
      }).then(res => {
        if (res.code == 0) {
          if (res.data.needCheck) {
            GetUserExpireTimer = setInterval(this.getUserExpireTime(), 90000);
            // GetUserExpireTimer = setInterval(this.getUserExpireTime(), 3000);
          }
          // 公告
          this.$store.commit("shNoticeShow", res.data.noticeShow);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    getUserExpireTime() {
      if (!this.token) return;
      getUserExpireTime({
        token: this.token
      }).then(res => {
        if (res.code == 0) {
          if (res.data > 0) {
            //剩余时间在5分钟到2分钟之间的，可以弹出打卡
            if (res.data <= 5 * 60 && res.data > 3 * 60) {
              // if (res.data <= 2591720) {
              if (this.activityCheckVisible) return;
              this.$store.commit("setActivityCheckVisible", true);
              LogoutTimer = setTimeout(() => {
                this.logout();
              }, 120000);
            } else if (res.data < 30) {
              this.logout();
            }
          }
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
          if (res.code == 100104 || res.code == 100105) {
            clearInterval(GetUserExpireTimer);
            clearTimeout(LogoutTimer);
          }
        }
      });
      return this.getUserExpireTime;
    },
    onSuccess() {
      clearTimeout(LogoutTimer);
      this.$message({
        message: "打卡成功",
        type: "success"
      });
      activeClock({
        token: this.token
      }).then(res => {
        if (res.msg == "success") {
          // 打卡成功
          //   this.dialogVisible = false;
          this.$store.commit("setActivityCheckVisible", false);
          this.$refs.slideblock.reset();
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    onFail() {
      this.$message({
        message: "打卡失败",
        type: "warning"
      });
    },
    onRefresh() {
      this.$message({
        message: "刷新成功",
        type: "success"
      });
    },
    logout() {
      this.$store.commit("setActivityCheckVisible", false);
      clearInterval(GetUserExpireTimer);
      clearTimeout(LogoutTimer);
      activeError({
        token: this.token
      });
      this.token = "";
      removeCookie("myToken");
      removeCookie("hasOrg");
      removeCookie("realNameAuth");
      removeCookie("redirect");
      removeCookie("redirectUrl");
      removeCookie("Inputphone");
      removeCookie("num");
      this.$message({
        message: "退出登陆成功",
        type: "success"
      });
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
>>> .yzmDialog {
  box-sizing: border-box;
  .el-dialog__header {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ActivityCheck.vue